// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","countdownColumns":"A7l3nqY8dCWHRbobKvfle"};